class Favorites {
  constructor(element) {
    this.favoritesButton = element;
    this.productHandle = this.favoritesButton.dataset.handle;
    this.updateButtonState(); // Call to set initial button state
  }

  // Add the current product to favorites
  addFavorite() {
    let prevStorage = JSON.parse(localStorage.getItem("favorites")) || [];
    prevStorage.push(this.productHandle); // Store the handle instead of the ID
    localStorage.setItem("favorites", JSON.stringify(prevStorage));
    this.updateButtonState(); // Update the button state after adding
  }

  // Remove the current product from favorites
  removeFavorite() {
    let prevStorage = JSON.parse(localStorage.getItem("favorites")) || [];
    const index = prevStorage.indexOf(this.productHandle); // Use this.productHandle instead of this.productId
    if (index > -1) {
      prevStorage.splice(index, 1); // Remove the product
      localStorage.setItem("favorites", JSON.stringify(prevStorage));
      this.updateButtonState(); // Update the button state after removing
    }
  }

  // Update the button's state based on whether the product is in favorites
  updateButtonState() {
    let favorites = JSON.parse(localStorage.getItem("favorites")) || [];
    if (favorites.includes(this.productHandle)) { // Use this.productHandle to check
      this.favoritesButton.textContent = "🗙 Remove from My Favorite Plans";
      this.favoritesButton.onclick = (e) => {
        e.preventDefault();
        this.removeFavorite();
      };
    } else {
      this.favoritesButton.textContent = "❤️ Add to My Favorite Plans";
      this.favoritesButton.onclick = (e) => {
        e.preventDefault();
        this.addFavorite();
      };
    }
  }
}

// Initialize the favorites feature on all favorite buttons
document.querySelectorAll(".favorites-button").forEach((button) => {
  new Favorites(button);
});

document.addEventListener("DOMContentLoaded", function() {
  const favoriteProductHandles = JSON.parse(localStorage.getItem("favorites")) || [];
  const productGrid = document.querySelector('.favorites-grid');

  if(!productGrid) { return; }

  if (favoriteProductHandles.length > 0) {
    favoriteProductHandles.forEach(handle => {
      fetch(`/products/${handle}.json`) // Use the handle for the API request
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to fetch product data for handle ${handle}: ${response.statusText}`);
          }
          return response.json();
        })
        .then(data => {
          const product = data.product;

          const productUrl = `https://c90c9d-1b.myshopify.com/products/${handle}`;

          // Create the <li> element
          const productElement = document.createElement('li');
          productElement.classList.add('grid__item', 'scroll-trigger', 'animate--slide-in');
          productElement.style.setProperty('width','100%');
          productElement.style.setProperty('max-width','330px');
          productElement.style.setProperty('max-height','400px');
          productElement.setAttribute('data-cascade', '');
          productElement.style.setProperty('--animation-order', '1');

          // Set the inner HTML of the <li> element
          productElement.innerHTML = `
            <link href="//c90c9d-1b.myshopify.com/cdn/shop/t/2/assets/component-rating.css?v=179577762467860590411716555246" rel="stylesheet" type="text/css" media="all">
            <link href="//c90c9d-1b.myshopify.com/cdn/shop/t/2/assets/component-volume-pricing.css?v=56284703641257077881716555246" rel="stylesheet" type="text/css" media="all">
            <link href="//c90c9d-1b.myshopify.com/cdn/shop/t/2/assets/component-price.css?v=70172745017360139101716555246" rel="stylesheet" type="text/css" media="all">
            <link href="//c90c9d-1b.myshopify.com/cdn/shop/t/2/assets/quick-order-list.css?v=158670895663024962971716555247" rel="stylesheet" type="text/css" media="all">
            <link href="//c90c9d-1b.myshopify.com/cdn/shop/t/2/assets/quantity-popover.css?v=78745769908715669131716555247" rel="stylesheet" type="text/css" media="all">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
                <div class="card__inner color-scheme-1 gradient ratio">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      <img src="${product.image.src}" alt="${product.title}" class="motion-reduce" width="350" height="226">
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading">
                        <a href="${productUrl}" style="text-align:center;color:#555;text-decoration:none;font-size:1.6rem;" class="full-unstyled-link">
                          ${product.title}
                        </a>
                      </h3>
                    </div>
                    <div class="card__badge bottom left"></div>
                  </div>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading h5">
                    <a href="${productUrl}" style="text-align:center;color:#555;text-decoration:none;font-size:1.6rem;" class="full-unstyled-link">
                      ${product.title}
                    </a>
                  </h3>
                  <div class="card-information">
                    <span class="caption-large light"></span>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>`;

          // Append the product element to the product grid
          productGrid.appendChild(productElement);
        })
        .catch(error => {
          console.error(error);
        });
    });
  } else {
    const message = document.querySelector('.empty-favorites-message');
    if (message) message.style.display = 'block';
  }
});
